import { Box, CircularProgress, Modal, Typography } from '@mui/material'
import React, { useState } from 'react'
import CloseIcon from '@mui/icons-material/Close'
import useStyles from './useStyles'
import { disableApplicationInstanceAppModule } from '../../../../app/services/eAuthz/DisableApplicationInstanceAppModuleEAuthz'
import {
  setErrorTextSnackBar,
  setRequestTextSnackBar,
  setSuccessTextSnackBar
} from '../../../../redux/actions/app'
import { useDispatch } from 'react-redux'
import { logEvent } from '../../../../utils/LogEvents'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 450,
  height: 225,
  bgcolor: 'white',
  p: 3,
  borderRadius: '8px',
  boxShadow: '0px 0px 4px rgba(36, 55, 143, 0.4)'
}

export const DisabledModule = ({ module, refresh, applicationInstanceId }) => {
  const classes = useStyles()
  const [showCircularProgress, setShowCircularProgress] = useState(false)
  const [openModal, setopenModal] = useState(false)


  const handleOpen = () => {
    setopenModal(true)
  }
  const dispatch = useDispatch()
  const disabledModule = async () => {
    setShowCircularProgress(true)
    try {
      const today = new Date()
      const yesterday = new Date()
      yesterday.setDate(today.getDate() - 1)

      const body = {
        applicationInstanceId: applicationInstanceId,
        appModuleCode: module.appModule,
        finishDate: yesterday.toISOString()
      }

      const response = await disableApplicationInstanceAppModule(body)
      logEvent('CGI - disableApplicationInstanceAppModule', {
        body: {
          body
        },
        response: response
      })
      dispatch(setRequestTextSnackBar())
      dispatch(setSuccessTextSnackBar('Deshabilitación exitosa'))
      refresh()
    } catch (error) {
      dispatch(setRequestTextSnackBar())
      dispatch(
        setErrorTextSnackBar('Ocurrió un error en un servicio de: eAuthzAPI')
      )
    }
    setShowCircularProgress(false)
  }

  return (
    <>
      <button className={classes.buttonDisabledModule} onClick={handleOpen}>
        <Typography
          className={classes.typographyButton}
          style={{
            color: '#263057'
          }}
        >
          Deshabilitar
        </Typography>
      </button>
      <Modal open={openModal} onClose={() => setopenModal(false)}>
        <Box sx={style}>
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <CloseIcon
              sx={{
                fontSize: 'medium',
                color: '#263057',
                cursor: 'pointer'
              }}
              onClick={() => setopenModal(false)}
            />
          </div>

          <div>
            <Typography sx={{ color: '#263057', fontSize: '1.3em' }}>
              Deshabilitar módulo {module.appModuleName}
            </Typography>
          </div>
          <Typography
            sx={{
              color: '#263057',
              fontFamily: 'Roboto',
              marginTop: '5%'
            }}
          >
            ¿Esta seguro de que desea deshabilitar el módulo?
          </Typography>

          <Box className={classes.buttons} style={{ marginLeft: '45%' }}>
            <ButtonConfirm
              showCircularProgress={showCircularProgress}
              disabledModule={disabledModule}
            />

            <ButtonClose handleClose={() => setopenModal(false)} />
          </Box>
        </Box>
      </Modal>
    </>
  )
}
function ButtonConfirm({ showCircularProgress, disabledModule }) {
  const classes = useStyles()
  const [isProgressComplete, setProgressComplete] = useState(false)

  const handleButtonClick = () => {
    if (!isProgressComplete && !showCircularProgress) {
      disabledModule()
      setProgressComplete(true)
    }
  }

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      <button
        className={`${classes.confirmButton} ${isProgressComplete ? classes.disabledButton : ''
          }`}
        disabled={isProgressComplete || showCircularProgress}
        onClick={handleButtonClick}
      >
        {showCircularProgress
          ? (
            <CircularProgress size="1.5rem" color="inherit" />
          )
          : (
            <Typography className={classes.confirmButtonTypography}>
              Deshabilitar
            </Typography>
          )}
      </button>
    </div>
  )
}

function ButtonClose({ handleClose }) {
  const classes = useStyles()

  return (
    <Box onClick={handleClose} className={classes.closeButton}>
      <Typography className={classes.closeButtonColor}>Cancelar</Typography>
    </Box>
  )
}
